import { useState } from 'react';
import axios from 'axios';

const useMonitorAPIService = (props) => {

    //! TRAMPA
    let hostName = window.location.hostname;
    const [server] = useState(
        hostName === 'localhost' || hostName === '127.0.0.1' || hostName === "dev.andrei.io" ?
            "http://devomni.andrei.io:8090/monitorservice" :
            "/monitorservice"
    );

    const login = (data, callBack) => {
        axios.post(`${server}/api/login`, data)
            .then(res => {
                callBack(res);
            })
            .catch(e => {
                callBack(false);
                error(e);
            });
    }

    const resend = (data, callBack) => {
        axios.post(`${server}/api/resend`, data)
            .then(res => {
                callBack(res);
            })
            .catch(e => {
                callBack(false);
                error(e);
            });
    }

    const checkhashedpass = (callBack) => {
        axios.get(`${server}/api/checkhashedpass`)
            .then(res => {
                callBack(res);
            })
            .catch(e => {
                callBack(false);
                error(e);
            });
    }

    const logout = (token, callBack) => {
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${server}/api/logout`,
            headers: {
                'Authorization': token
            },
            data: token
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }

    const changePassword = (token, data, callBack) => {
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${server}/api/changePassword`,
            headers: {
                'Authorization': token
            },
            data: data
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }

    const getMonitorSettings = (token, callBack) => {

        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${server}/api/getMonitorSettings`,
            headers: {
                'Authorization': token
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }

    const updateMonitorSettings = (token, data, callBack) => {
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${server}/api/updateMonitorSettings`,
            headers: {
                'Authorization': token
            },
            data: data
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }


    const getSupervisedAgents = (token, callBack) => {
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${server}/api/getSupervisedAgents`,
            headers: {
                'Authorization': token
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }

    const getUserParameters = (token, callBack) => {
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${server}/api/getUserParameters`,
            headers: {
                'Authorization': token
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }

    const updateAlarmsParameter = (token, data, callBack) => {
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${server}/api/setAlarmsParameter`,
            headers: {
                'Authorization': token
            },
            data: data
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }

    const error = (e) => {
        if (e.response.status === 403 || e.response.status === 401) {
            const event = new Event('apiErrorForbidden');
            document.dispatchEvent(event);
        }
    }

    const getSupervisedGroups = (token, callBack) => {

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${server}/api/getSupervisedGroups`,
            headers: {
                'Authorization': token
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }

    const getUserGroups = (token, userId, callBack) => {
        let config = {
            method: 'post',
            data: userId,
            maxBodyLength: Infinity,
            url: `${server}/api/GetGroupsUserIs`,
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }

    const getChatUrl = (token, callBack) => {
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${server}/api/getChatUrl`,
            headers: {
                'Authorization': token
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }

    const checkIfRecordingIsAvailable = (token, callBack) => {
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${server}/api/checkIfRecordingIsAvailable`,
            headers: {
                'Authorization': token
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }

    const disassociate = (userId, ext, token, callBack) => {

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${server}/api/disassociate`,
            data: {
                pin: userId,
                ext: ext
            },
            headers: {
                'Authorization': token
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }

    const pause = (userId, ext, token, callBack) => {

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${server}/api/pause`,
            data: {
                pin: userId,
                ext: ext
            },
            headers: {
                'Authorization': token
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }


    const loginACD = (userId, ext, token, callBack) => {

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${server}/api/loginACD`,
            data: {
                pin: userId,
                ext: ext
            },
            headers: {
                'Authorization': token
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }

    const refreshAgentStatus = (token, userId, callBack) => {
        let config = {
            method: 'post',
            data: userId,
            maxBodyLength: Infinity,
            url: `${server}/api/refreshAgentStatus`,
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }

    const startRecording = (token, ext, callBack) => {
        let config = {
            method: 'post',
            data: ext,
            maxBodyLength: Infinity,
            url: `${server}/api/startRecording`,
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }

    const stopRecording = (token, ext, callBack) => {
        let config = {
            method: 'post',
            data: ext,
            maxBodyLength: Infinity,
            url: `${server}/api/stopRecording`,
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }

    const reloadAgentData = (token, userId, callBack) => {
        let config = {
            method: 'post',
            data: userId,
            maxBodyLength: Infinity,
            url: `${server}/api/getUserData`,
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }

    const getUserStatus = (token, userId, callBack) => {
        let config = {
            method: 'post',
            data: userId,
            maxBodyLength: Infinity,
            url: `${server}/api/getUserStatus`,
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }

    const changeUserGroupPriority = (token, data, callBack) => {
        let config = {
            method: 'post',
            data: data,
            maxBodyLength: Infinity,
            url: `${server}/api/ChangeUserGroupPriority`,
            headers: {
                'Authorization': token
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }
    const changeChannelStatus = (token, data, callBack) => {
        let config = {
            method: 'post',
            data: data,
            maxBodyLength: Infinity,
            url: `${server}/api/changeChannelStatus`,
            headers: {
                'Authorization': token
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }

    const getSupervisedGroupsStats = (token, callBack) => {
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${server}/api/getSupervisedGroupsStats`,
            headers: {
                'Authorization': token
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }

    const transferCallToAgent = (token, data, callBack) => {

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${server}/api/transferCallToAgent`,
            data: data,
            headers: {
                'Authorization': token
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }

    const getCampaignStatus = (token, id, callBack) => {

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${server}/api/updateCampaignStatus`,
            data: id,
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }

    const changeCampaignStatus = (token, id, callBack) => {

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${server}/api/changeCampaignStatus`,
            data: id,
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }

    const changeGroupStatus = (token, data, callBack) => {

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${server}/api/ChangeGroupStatus`,
            data: data,
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }
    const changeGroupPriority = (token, data, callBack) => {

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${server}/api/ChangeGroupPriority`,
            data: data,
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }


    const getGroupAgents = (token, id, callBack) => {

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${server}/api/getGroupAgents`,
            data: id,
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }

    const checkRecover = (data, callBack) => {
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${server}/api/checkrecoverpwd`,
            data: data
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }

    const recoverPwd = (data, callBack) => {
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${server}/api/recoverPwd`,
            data: data
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }

    const saveLayout = (token, data, callBack) => {
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${server}/api/updateLayout`,
            data: data,
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }

    const getPasswordPolicy = (token, data, callBack) => {
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${server}/api/checkPassword`,
            data: data,
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }
    const getSupervisedCorporateGroups = (token, callBack) => {

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${server}/api/getSupervisedCorporateGroups`,
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });

    }

    const setCorporateGroup = (token, data, callBack) => {

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${server}/api/setCorporateGroup`,
            headers: {
                'Authorization': token
            },
            data: data
        };

        axios.request(config).then((res) => {
            callBack(res);
        }).catch((e) => {
            callBack(false);
            error(e);
        });

    }
    const removeCorporateGroup = (token, data, callBack) => {

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${server}/api/removeCorporateGroup`,
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            },
            data: data
        };

        axios.request(config).then((res) => {
            callBack(res);
        }).catch((e) => {
            callBack(false);
            error(e);
        });

    }
    const getSupervisors = (token, callBack) => {

        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${server}/api/supervisors`,
            headers: {
                'Authorization': token
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });
    }

    const getOwnCorporateGroups = (token, callBack) => {

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${server}/api/getOwnCorporateGroups`,
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                error(e);
            });

    }

    const addRemoveUserGroups = (token, data, callBack) => {
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${server}/api/addRemoveUserGroups`,
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            },
            data: data
        };

        axios.request(config).then((res) => {
            callBack(res);
        }).catch((e) => {
            callBack(false);
            error(e);
        });
    }

    const intrusion = (token, data, callBack) => {

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${server}/api/intrusion`,
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            },
            data: data
        };

        axios.request(config).then((res) => {
            callBack(res);
        }).catch((e) => {
            callBack(false);
            error(e);
        });
    }


    return {
        login, resend, checkhashedpass, logout, changePassword, getMonitorSettings, updateMonitorSettings, getSupervisedAgents,
        getUserParameters, updateAlarmsParameter, getSupervisedGroups, getUserGroups, getChatUrl, checkIfRecordingIsAvailable,
        disassociate, pause, loginACD, refreshAgentStatus, startRecording, stopRecording, reloadAgentData, getUserStatus,
        changeUserGroupPriority, changeChannelStatus, getSupervisedGroupsStats, transferCallToAgent, getCampaignStatus,
        changeCampaignStatus, changeGroupStatus, changeGroupPriority, getGroupAgents, checkRecover,
        recoverPwd, saveLayout, getPasswordPolicy, getSupervisedCorporateGroups, setCorporateGroup, removeCorporateGroup, getSupervisors,
        getOwnCorporateGroups, addRemoveUserGroups, intrusion
    };
}

export default useMonitorAPIService;
